import { DomainHTTP } from '@/http'
import { TOKEN } from '@/utils'
import { DomainViewModel } from '@/view-models'
import { BulkDomainSearchViewModel } from '@orderForm/view-models'
import {
  BulkDomainSearchBox,
  BulkDomainSearchDomainResultListView,
  BulkDomainSearchSelectedTldListView,
  BulkDomainSearchTldListView
} from '@orderForm/views'

/**
 * @description Bootstraps the Bulk Domain Search Page
 */
export const setupBulkDomainSearch = (): void => {
  // Get Root El
  const rootEl = document.querySelector<HTMLElement>(
    '.js-domain-search__bulk-content-area'
  )

  // Check if it should Run
  if (!rootEl) {
    return
  }

  // Init Vars
  const searchBoxWidget = rootEl.querySelector<HTMLElement>(
    '.js-domain-search__bulk-search'
  )
  const selectedTldContainerEl = rootEl.querySelector<HTMLElement>(
    '.js-domain-search__selected-tld-list'
  )
  const tldListEl = rootEl.querySelector<HTMLAnchorElement>(
    '.js-domain-search__bulk-tld-list'
  )
  const domainResultsContainer = rootEl.querySelector<HTMLElement>(
    '.js-domain-search__bulk-result-list'
  )
  const token = TOKEN

  // Handle Null Errors
  if (!searchBoxWidget) {
    throw new Error('setupBulkDomainSearch: searchBoxWidget is null')
  }

  if (!token) {
    throw new Error('setupBulkDomainSearch: TOKEN is null')
  }

  if (!selectedTldContainerEl) {
    throw new Error('setupBulkDomainSearch: selectedTldContainerEl is null')
  }

  if (!domainResultsContainer) {
    throw new Error('setupBulkDomainSearch: domainResultsContainer is null')
  }

  if (!tldListEl) {
    throw new Error('setupBulkDomainSearch: tldListEl is null')
  }

  // Bootstrap the various components
  const domainHTTP = new DomainHTTP()
  const bulkDomainViewModel = new BulkDomainSearchViewModel(domainHTTP, token)
  const domainViewModel = new DomainViewModel(domainHTTP)

  const selectedTldListView = new BulkDomainSearchSelectedTldListView(
    selectedTldContainerEl,
    bulkDomainViewModel
  )

  const tldListView = new BulkDomainSearchTldListView(
    tldListEl,
    selectedTldListView
  )

  const domainResultsView = new BulkDomainSearchDomainResultListView(
    domainResultsContainer,
    domainViewModel,
    token
  )

  new BulkDomainSearchBox(
    searchBoxWidget,
    domainResultsView,
    tldListView,
    selectedTldListView,
    bulkDomainViewModel
  )
}
